import { WxRadio } from "../..";
import {
  PriceRange,
  useFiltersContext,
} from "../../../hooks/context/useFiltersContext";
import { formatRange } from "../../../utils/formatRange";

interface Props {
  r: PriceRange;
}

export const RangeFilter = ({ r }: Props) => {
  const { range, toggleRange } = useFiltersContext();

  return (
    <WxRadio
      label={formatRange(r)}
      value={`${r.max ?? r.min}`}
      radioName={"priceRange"}
      selected={r.max === range?.max && r.min === range?.min}
      allowUnselect
      onChange={() => toggleRange(r)}
    />
  );
};
